import React from 'react';
import { Navigate } from 'react-router-dom';
import checkSession from '../../../../../util/Common/Router/Handler/checkSession';
import checkPermission from '../../../../../util/Common/Router/Handler/checkPermission';
import ErrorAccessDenied from '../../../Error/ErrorAccessDenied';

const AuthRouter = ({ children, ...props }) => {
  const { permission } = props;

  /** Check logged in */
  const isLoggedIn = checkSession();
  if (!isLoggedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  /** Check permission */
  const isPermitted = checkPermission({ permission });
  if (!isPermitted) {
    return <ErrorAccessDenied />;
  }

  return children;
};

export default AuthRouter;
